import { _ } from "core-js"
import Vue from "vue"

/**
 * ======================================================================
 *  GETTERS
 * ======================================================================
 */
const getters = {
    get: (state, getters, rootState) => rootState.appStore.application.applicants
}

/**
 * ======================================================================
 *  MUTATIONS
 * ======================================================================
 */
const mutations = {
    addApplicant(state, applicant) {
        this.state.appStore.application.applicants.push(applicant)
    },
    setApplicants(state, applicants) {
        if (_.isObject(applicants)) {
            let applicant = {}
            if (!_.isEmpty(this.state.appStore.application.applicants)) {
                if (_.has(applicants, 'index', false)) {
                    let index = applicants.index
                    delete applicants.index
                    applicant = this.state.appStore.application.applicants[index]
                    if (!_.isEmpty(applicant)) {
                        Vue.set(this.state.appStore.application.applicants, index, {...applicant, ...applicants})
                    }
                }
            } else {
                delete applicants.index
                this.state.appStore.application.applicants.push(applicants)
            }
        } else if (_.isArray(applicants)) {
            Vue.set(this.state.appStore.application, 'applicants', {...this.state.appStore.application.applicants, ...applicants})
        }
    },
    removeApplicant(state, applicantIndex) {
        this.state.appStore.application.applicants.splice(applicantIndex, 1)
    },
    setActiveApplicant(state, index) {
        Vue.set(this.state.appStore.application.applicants, 'applicant', this.state.appStore.application.applicants[index])

        if (_.get(this.state, 'appStore.application.applicants.applicant', false)) {
            Vue.set(this.state.appStore.application.applicants.applicant, 'index', index)
        }
    }
}

/**
 * ======================================================================
 *  ACTIONS
 * ======================================================================
 */
const actions = {
    add({ commit, dispatch, rootState }, applicant) {
        commit("addApplicant", applicant)
    },
    set({ commit }, applicants) {
        commit("setApplicants", applicants)
    },
    remove({ commit }, applicantIndex) {
        commit('removeApplicant', applicantIndex)
    },
    setActive({ commit, dispatch }, index) {
        commit("setActiveApplicant", index)
    },
}

export default {
    namespaced: true,
    namespace: "application/applicants",
    modules: getModules('applicants'),
    state: {},
    getters,
    mutations,
    actions
}
